// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTable-AuxDateWrapper_cls1__osgLY","cls2":"VeloTable-AuxDateWrapper_cls2__TjJIF VeloTable-AuxDateWrapper_cls1__osgLY"};